import React, { useMemo } from 'react';
import { TEditCustomerSelectedClientType } from '../../../editCustomerState/editCustomerContext';
import { ISelectOption } from 'components/Select/types';
import { clientTypes } from 'appConstants';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { Icon, IconName } from 'components/Icon/Icon';
import { FormSelectNew } from 'components/Select/FormSelectNew';

const clientTypeIcons: Record<string, IconName> = {
	clientTypeHotels: IconName.clientTypeHotels,
	clientTypeRestaurants: IconName.clientTypeRestaurants,
	clientTypeFastFood: IconName.clientTypeFastFood,
};

interface IProps {
	setClientType: (value: TEditCustomerSelectedClientType) => void;
}

export const ClientTypeSelect: React.FC<IProps> = React.memo(({ setClientType }) => {
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectClientType') }], [t]);

	const options = useMemo<ISelectOption[]>(
		() =>
			clientTypes.map((clientType) => ({
				id: clientType.clientTypeID,
				name: tForm(clientType.clientTypeName),
				icon: (
					<Icon name={clientTypeIcons[clientType.clientTypeName]} size="lg" className="text-purple-07-new" />
				),
			})),
		[tForm],
	);

	return (
		<FormSelectNew
			testId="ClientTypeSelect"
			name="clientType"
			label="clientTypeLabel"
			options={options}
			withSearch={false}
			validationRules={validationRules}
			onChange={setClientType}
		/>
	);
});
